import styled from 'styled-components';

export const StyledCardAvisosOptions = styled.article`
border: solid #E8E8E8 1px;
border-radius: .25rem;
padding: 0.3rem;
margin: 0.2rem;
background-color: #fff;
height: fit-content;
text-align: center;

.hover {
    &:hover {
        cursor: pointer;
    }
}

& .info-sections {
    width: 100%;
    font-si
}

& .menu-sections {
    width: 10%;
}

.title-card {
    font-weight: 1000;
    font-size: 11px;
}

.title-card-legend {
    color: gray;
    font-size: 11px;
}

.data-info {
    color: gray;
    font-weight: 1000;
    font-size: 14px;
}

.card-align {
    text-align: center;
    height : 130px;
}

@media screen and (max-width: 600px)  {

        .card-align {
            text-align: center;
            height : 150px;
        }

}

@media screen and (min-width: 1600px)  {

    .card-align {
        text-align: center;
        height : 140px;
    }

}

.legend-activity {
    font-size: 1rem;
    margin: 0.5rem;
}

.legend-time {
    font-size: 14px;
    color: #2c3b82;
    font-weight: 1000;
}

.legend-title-text-bold {
    font-size: 15px;
    font-weight: 1000;
    text-align: left;
}

.legend-title-text-bold-1 {
    font-size: 12px;
    font-weight: 1000;
    text-align: left;
}
.text-max-35{
    white-space: nowrap;
    max-width: 50ch;
    overflow: hidden;
    text-overflow: ellipsis;
}

.legend-title-text-1 {
    font-size: 12px;
    font-weight: 1000;
    text-align: left;
}

.legend-title-text-2 {
    font-size: 10px;
    font-weight: 1000;
    text-align: left;
}

.legend-title-text {
    font-size: 14px;
    text-align: left;
}

.legend-value {
    font-size: 14px;
    color: green;
    font-weight: 1000;
}


.name-info {
    color: #2c3b82;
    font-weight: 1000;
    font-size: 14px;
    background: #E8E8E8;
    border-radius: 10px;
}

.text-align-center-icon div {
    align-items: center;
    justify-content: center;
    margin-top: 8px !important;
}

.flex-column-1 {
    width: 50%;
}

.flex-column-2 {
    width: 50%;
}

.flex-column-title {
    width: 100%;
    text-align: left;
}

.flex-column-title-icon {
    text-align: right;
}

.button-icon {
    background: transparent;
    border: none;
}

.menu-popup {
    width: 50%;
    background: black;
    color: white;
    z-index: 9;
}

.flex-column-left {
    margin-left: 0.5rem;
    width: 100%;
    text-align: left;
}

.flex-title-full {
    margin-left: 0.5rem;
    text-align: left;
    width: 100%;
}

.flex-title-left {
    margin-left: 0.5rem;
    text-align: left;
    width: 50%;
}

.flex-column-right {
    margin-right: 0.5rem;
    width: 50% !important;
    text-align: right;
}

.flex-column-right-70 {
    margin-right: 0.5rem;
    width: 70% !important;
    text-align: right;
}


.flex-column-right-80 {
    margin-right: 0.5rem;
    width: 80% !important;
    text-align: right;
}

.flex-column-right-100 {
    margin-right: 0.5rem;
    width: 100% !important;
    text-align: right;
}

.timesheet .flex-column-right {
    margin-right: 0.5rem;
    width: 50% !important;
    align-items: right;
}

.timesheet .flex-column-right-100 {
    margin-right: 0.5rem;
    width: 100% !important;
    text-align: right;
}

.flex-workflow-right {
    justify-content: right;
}

.flex-title-text-left {
    margin-right: 0.5rem;
    text-align: left;
    width: 50%;
}

.flex-title-icon-center {
    text-align: center;
    margin-top: 0.5rem;
    width: 10%;
}

.flex-text-justify {
    text-align: justify;
    margin-top: 0.5rem;
    font-size: 0.9rem;

}

.flex-column-title-right {
    width: 10%;
    text-align: left;
}

.footer-details {
    color: #2c3b82;
    font-size: 13px;
    white-space: nowrap;
}

.footer-details-bold {
    color: #2c3b82;
    width: 100%;
    font-weight: 1000;
    font-size: 11px;
}

.flex-column-footer-1 {
    margin-left: 0.5rem;
    width: 30%;
    text-align: left;
}

.flex-column-footer-2 {
    width: 70%;
    text-align: right;
}

.card-menu-hide {
    background: black;
    color: #fff;
    margin: 1rem;
    font-size: 11px;
    display: none;
    width: 50%;
    padding: 5px;
    border-radius: 7px;
}

.card-menu-show {
    ext-align: left;
    background: black;
    color: blue;
    margin-top: 1.5rem;
    font-size: 11px;
    display: block;
    position: absolute;
    padding: 5px;
    border-radius: 7px;
    color: blue;
    background-color: white;
    border-radius: 12px;
    border: 1px solid #E8E8E8;
    box-shadow: 0px 0px 24px rgba(0,0,0,0.05);
    font-size: 13px;
    margin-left: -20px;
}


@media screen and (max-width: 600px)  {

    .card-menu-show{
        margin-left: -30px;
    }
}


@media screen and (min-width: 601px) and (max-width: 1400px)  {

    .card-menu-show{
        margin-left: -38px;
    }
}



@media screen and (min-width: 1401px) and (max-width: 1980px)  {

    .card-menu-show{
        margin-left: -10px;
    }
}


.card-menu-title {
    width: 75%;
    text-align: right;
}

.card-menu-title-right {
    width: 25%;
    text-align: right;
}

.menu-card {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    border-bottom: 0px solid #fff;
    color: #000;
    line-height: 2.5;
}


/* theming */
.btn{
    width: 16.66666667% important!;
    padding: 1px 5px;
	font-size: 12px;
	line-height: 1.5;
	border-radius: 3px;
}
.alert-success {
    color: #ffffff;
    background-color: rgba(38, 185, 154, 0.88);
    border-color: rgba(38, 185, 154, 0.88);
}

.alert-info {
    color: #E9EDEF;
    background-color: rgba(52, 152, 219, 0.88);
    border-color: rgba(52, 152, 219, 0.88);
}

.alert-warning {
    color: #E9EDEF;
    background-color: rgba(243, 156, 18, 0.88);
    border-color: rgba(243, 156, 18, 0.88);
}

.alert-danger,
.alert-error {
    color: #E9EDEF;
    background-color: rgba(231, 76, 60, 0.88);
    border-color: rgba(231, 76, 60, 0.88);
}

.alert-dark,
.btn-dark {
    color: #E9EDEF;
    background-color: rgba(52, 73, 94, 0.88);
    border-color: rgba(52, 73, 94, 0.88);
}

.btn-dark:hover {
    color: #F7F7F7;
}
/* /theming */
/* /Pnotify by Hunter Perrin :: 2.0.1 */

.btn.btn-outline {
    background: transparent;
}

.btn-primary.btn-outline {
    color: #1A82C3;
    border-width: 2px;
}

.btn-default.btn-outline {
    color: #34495e;
    border-width: 2px;
}

.btn-success.btn-outline {
    color: #1ABB9C;
    border-width: 2px;
}

.btn-info.btn-outline {
    color: #34495e;
    border-width: 2px;
}

.btn-warning.btn-outline {
    color: #5bc0de;
    border-width: 2px;
}

.btn-danger.btn-outline {
    color: #34495e;
    border-width: 2px;
}

.btn-dark.btn-outline {
    color: #c0392b;
    border-width: 2px;
}

.btn-warning {
    background: #f0ad4e;
    border-color: #f0ad4e;
}

.btn-danger {
    background: #d9534f;
    border-color: #d9534f;
}

.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active,
.btn-primary.active,
.open .dropdown-toggle.btn-primary {
    background-color: #1A82C3;
    border-color: #1A82C3;
    color: #FFFFFF;
}

.btn-success:hover,
.btn-success:focus,
.btn-success:active,
.btn-success.active,
.open .dropdown-toggle.btn-success {
    background-color: #1ABB9C;
    border-color: #1ABB9C;
    color: #FFFFFF;
}

.btn-info:hover,
.btn-info:focus,
.btn-info:active,
.btn-info.active,
.open .dropdown-toggle.btn-info {
    background-color: #4FB5D3;
    border-color: #4FB5D3;
    color: #FFFFFF;
}

.btn-warning:hover,
.btn-warning:focus,
.btn-warning:active,
.btn-warning.active,
.open .dropdown-toggle.btn-warning {
    background-color: #d58512;
    border-color: #d58512;
    color: #FFFFFF;
}

.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active,
.btn-primary.active,
.open .dropdown-toggle.btn-primary {
    background-color: #1479B8;
    border-color: #1479B8;
    color: #FFFFFF;
}

.btn-danger:hover,
.btn-danger:focus,
.btn-danger:active,
.btn-danger.active,
.open .dropdown-toggle.btn-danger {
    background-color: #d43f3a;
    border-color: #d43f3a;
    color: #FFFFFF;
}

.btn-dark:hover,
.btn-dark:focus,
.btn-dark:active,
.btn-dark.active,
.open .dropdown-toggle.btn-dark {
    background-color: #394D5F;
    border-color: #394D5F;
    color: #FFFFFF;
}

.custom-notifications {
    position: fixed;
    margin: 15px;
    right: 0;
    float: right;
    width: 400px;
    z-index: 4000;
    bottom: 0;
}

.btn-round {
    border-radius: 30px;
}



.text-max-3-lines {
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
}


.swal2-title{
    text-align: left;
}

`